import axios from "axios";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useState } from "react";
import MaskedInput from "react-maskedinput";
import { useHistory } from "react-router-dom";
import schema from "./schema";

import { connect } from "react-redux";
import {
  CreateHeadersApiGetnet,
  SaveDataClientGetNet,
} from "../../../actions/ApiGentnetActions";
import { exibeModal } from "../../../actions/ModalActions";

import { geraTokenGetnet } from "../../../services/ApiGetnetService";

import { consultaCep } from "../../../Utils";

import { editIdCliente } from "../../../actions/ClientesActions";
import Card from "../../../components/Card";
import Footer from "../../../components/Footer";
import HeaderInterno from "../../../components/HeaderInterno";
import { LoadingGif } from "../../../components/LoadingGif";
import Modal from "../../../components/Modal";

const Cadastro = ({
  exibeModal,
  clientName,
  editIdCliente,
  CreateHeadersApiGetnet,
  SaveDataClientGetNet,
  plano,
}) => {
  const [exibeLoading, setExibeLoading] = useState(false);
  const [mostraModal, setMostraModal] = useState(false);
  const [msg, setMsg] = useState("");
  const [bgColor, setBgColor] = useState("");
  const [titulo, setTitulo] = useState("");
  const [redirPagameto, setRedirPagamento] = useState(false);
  //const [reqIncludeClientDB] = useState({});
  const [userId, setUserId] = useState(0);
  const history = useHistory();

  const modal = (titulo, bgColor, msg) => {
    return (
      <Modal
        isOpen={true}
        title={titulo}
        classCssHeader={`${bgColor} color-white`}
      >
        <p>{msg}</p>
      </Modal>
    );
  };

  //função para preencher o endereço
  const preencheEndereco = (ev, cep, setFieldValue) => {
    ev.preventDefault();
    consultaCep(cep).then((data) => {
      //const logradouro = `${data.tipo_logradouro} ${data.logradouro}`;
      setFieldValue("endereco", data.logradouro);
      setFieldValue("bairro", data.bairro);
      setFieldValue("cidade", data.localidade);
      setFieldValue("uf", data.uf);
    });
  };

  //FUNÇÃO PARA BUSCAR OS DADOS DO CLIENTE PELO CPF
  const getDadosClienteCpf = async (cpf) => {
    if (cpf) {
      const dadosCliente = await axios.get(
        process.env.REACT_APP_API_URL + "clientes/listar?cpf=" + cpf,
      );

      return dadosCliente.data;
    }

    return { status: "sucesso", dados: [] };
  };

  //FUNÇÃO QUE PREENCHE OS DADOS DO CLIENTE NO FORMULÁRIO PELO CPF
  const preencheDadosCpf = async (ev, cpf, setFieldValue) => {
    ev.preventDefault();

    const dadosCliente = await getDadosClienteCpf(cpf);

    if (dadosCliente.status === "sucesso") {
      if (dadosCliente.dados.length > 0) {
        setUserId(dadosCliente.dados[0].id);

        setFieldValue("nome", dadosCliente.dados[0].nome || "");
        setFieldValue("sobrenome", dadosCliente.dados[0].sobrenome || "");
        setFieldValue("dataNasc", dadosCliente.dados[0].data_nasc || "");
        //setFieldValue("sexo", dadosCliente.dados[0].sexo || "");
        setFieldValue("cep", dadosCliente.dados[0].cep || "");
        setFieldValue("endereco", dadosCliente.dados[0].endereco || "");
        setFieldValue("numero", dadosCliente.dados[0].numero || "");
        setFieldValue("complemento", dadosCliente.dados[0].complemento || "");
        setFieldValue("bairro", dadosCliente.dados[0].bairro || "");
        setFieldValue("uf", dadosCliente.dados[0].uf || "");
        setFieldValue("cidade", dadosCliente.dados[0].cidade || "");
        setFieldValue("email", dadosCliente.dados[0].email || "");
        setFieldValue("dddCel", dadosCliente.dados[0].ddd_celular || "");
        setFieldValue("celular", dadosCliente.dados[0].celular || "");

        //Preebchendo os dados do dependentes
        if (dadosCliente.dados[0].dependentes.length > 0) {
          dadosCliente.dados[0].dependentes.map((item, index) => {
            setFieldValue(`dependente[${index}][id]`, item.id || "");
            setFieldValue(`dependente[${index}][cpf]`, item.cpf || "");
            setFieldValue(`dependente[${index}][nome]`, item.nome || "");
            setFieldValue(`dependente[${index}][email]`, item.email || "");
            setFieldValue(
              `dependente[${index}][dddCel]`,
              item.ddd_celular || "",
            );
            setFieldValue(`dependente[${index}][celular]`, item.celular || "");

            setFieldValue(
              `dependente[${index}][data_nasc]`,
              item.data_nasc || "",
            );
            setFieldValue(
              `dependente[${index}][grau_parentesco]`,
              item.grau_parentesco || "",
            );
          });
        }
      }
    }
  };

  //submetendo o formulário
  const handleSubmit = async (values, actions) => {
    //Cadastrando os dados do cliente no banco de dados
    setExibeLoading(true);
    try {
      let includeClientDB;

      //verifica se o cliente já existe no banco de dados
      if (userId) {
        //salvando o id do cliente no redux
        editIdCliente(userId);

        //atualizar cliente
        includeClientDB = await axios.put(
          process.env.REACT_APP_API_URL + "cliente/atualizar/" + userId,
          values,
        );
      } else {
        includeClientDB = await axios.post(
          process.env.REACT_APP_API_URL + "cliente/cadastrar",
          values,
        );
      }

      //CADASTRANDO O CLIENTE NO BANCO DE DADOS
      /*const includeClientDB = await axios.post(
        process.env.REACT_APP_API_URL + "cliente/cadastrar",
        values
      );*/

      if (includeClientDB.data.status === "erro") {
        setTitulo("Erro " + includeClientDB.data.status);
        setBgColor("bg-danger");
        setMsg("Erro ao realizar a assinatura. " + includeClientDB.data.msg);
        setMostraModal(true);
        exibeModal(true);
      } else {
        //SE FOR UM CLIENTE NOVO ELE SALVA O ID DELE NO REDUX
        if (!userId) {
          //salvando o id do cliente no redux
          editIdCliente(includeClientDB.data.dados.cliente_id);
        }

        try {
          //gerando o token de acesso na API Getnet (função utils)
          const geraToken = await geraTokenGetnet(clientName);

          if (geraToken.data.status === "erro") {
            setTitulo("Erro " + geraToken.data.status);
            setBgColor("bg-danger");
            setMsg("Erro ao realizar a assinatura. " + geraToken.data.msg);
            setMostraModal(true);
            exibeModal(true);
          } else {
            const { access_token } = geraToken.data.dados.token;
            const headers = {
              headers: {
                Authorization: access_token,
                "Content-Type": "application/json",
                clientName: clientName,
                SellerId: process.env.REACT_APP_SELLERID_API_GETNET,
              },
            };

            //salvando os dados do header no redux
            CreateHeadersApiGetnet(headers);
            try {
              const valuesForm = {
                first_name: values.nome,
                last_name: values.sobrenome,
                document_type: "CPF",
                document_number: values.cpf.replace(/\D/g, ""),
                email: values.email,
              };

              //url que lista o cliente na API Getnet
              const urlListaClienteGetnet = `${process.env.REACT_APP_APIGETNET_URL}listarClientes?page=1&limit=25&document_number=${valuesForm.document_number}`;

              //Faz a requisição para verificar se o cliente já existe na API Getnet
              const listaClienteGetnet = await axios.get(
                urlListaClienteGetnet,
                headers,
              );

              if (listaClienteGetnet.data.erro === 1) {
                setTitulo("Erro " + listaClienteGetnet.data.status);
                setBgColor("bg-danger");
                setMsg(
                  "Erro ao realizar a assinatura. " +
                    listaClienteGetnet.data.msg,
                );
                setMostraModal(true);
                exibeModal(true);
              }

              /**
               * criar uma variavel para salvar os dados do cliente para salvar no redux
               */
              let dadosClienteGetnet = {};

              //se o cliente já existir na API Getnet
              if (listaClienteGetnet.data.dados.customers.length > 0) {
                dadosClienteGetnet = listaClienteGetnet.data.dados.customers[0];
              } else {
                //fazendo o cadastro do cliente na API Getnet
                const includeClientGetnet = await axios.post(
                  process.env.REACT_APP_APIGETNET_URL + "cadastrarCliente",
                  valuesForm,
                  headers,
                );

                if (includeClientGetnet.data.status === "erro") {
                  setTitulo("Erro " + includeClientGetnet.data.status);
                  setBgColor("bg-danger");
                  setMsg(
                    "Erro ao realizar a assinatura. " +
                      includeClientGetnet.data.msg,
                  );
                  setMostraModal(true);
                  exibeModal(true);
                } else {
                  dadosClienteGetnet = includeClientGetnet.data.dados;
                }
              }

              //salvando os dados do cliente no redux
              SaveDataClientGetNet(dadosClienteGetnet);

              //redirecionando para a página de pagamento
              setRedirPagamento(true);
            } catch (error) {
              setTitulo("Erro");
              setBgColor("bg-danger");
              setMsg("Erro ao realizar a assinatura. " + error);
              setMostraModal(true);
              exibeModal(true);
            }
          }
        } catch (error) {
          setTitulo("Erro");
          setBgColor("bg-danger");
          setMsg("Erro ao realizar a assinatura. " + error);
          setMostraModal(true);
          exibeModal(true);
        }
      }
    } catch (error) {
      setTitulo("Erro");
      setBgColor("bg-danger");
      setMsg("Erro ao realizar a assinatura. " + error);
      setMostraModal(true);
      exibeModal(true);
    } finally {
      setExibeLoading(false);
    }
  };

  if (redirPagameto) {
    history.push("/pagamento");
  }

  return (
    <>
      <HeaderInterno tituloHeader="Formulário de cadastro" />
      <div className="container">
        {mostraModal ? modal(titulo, bgColor, msg) : ""}

        {exibeLoading && <LoadingGif />}

        <section className="container-form">
          <Formik
            onSubmit={handleSubmit}
            initialValues={{
              cpf: "",
              dataNasc: "",
              nome: "",
              sobrenome: "",
              //sexo: "",
              cep: "",
              endereco: "",
              numero: "",
              complemento: "",
              bairro: "",
              uf: "",
              cidade: "",
              email: "",
              //ddd_telefone: "21",
              //telefone: "3333-3333",
              dddCel: "",
              celular: "",
              /*senha: "12345678",
                confirmaSenha: "12345678",
                plano_id: this.props.plano.id,
                dependentes: [
                                    { cpf: "", nomeDependente: "", nascDependente: "", parentesco: "" },
                                    { cpf: "", nomeDependente: "", nascDependente: "", parentesco: "" },
                                    { cpf: "", nomeDependente: "", nascDependente: "", parentesco: "" },
                                ]*/
            }}
            validationSchema={schema}
            render={({ values, setFieldValue }) => (
              <Form className="clearfix">
                <Card textoHeader="Dados do Titular">
                  <div className="row">
                    <div className="col-xs-12 col-lg-2">
                      <div className="form-group">
                        <label>CPF: </label>
                        <Field name="cpf">
                          {({ field, form }) => (
                            <MaskedInput
                              {...field}
                              type="text"
                              className="form-control input-sm cpf_valido"
                              mask="111.111.111-11"
                              onBlur={async (e) => {
                                form.setFieldTouched("cpf", true); // marca como tocado
                                form.setFieldValue("cpf", e.target.value); // atualiza valor
                                //busca os dados do cliente pelo CPF
                                await preencheDadosCpf(
                                  e,
                                  e.target.value,
                                  form.setFieldValue,
                                );
                              }}
                              disabled={userId > 0}
                            />
                          )}
                        </Field>
                        <span className="error-message">
                          <ErrorMessage name="cpf" />
                        </span>
                      </div>
                    </div>
                    <div className="col-xs-12 col-lg-4">
                      <div className="form-group">
                        <label>Nome: </label>
                        <Field
                          type="text"
                          name="nome"
                          className="form-control input-sm"
                        />
                        <span className="error-message">
                          <ErrorMessage name="nome" />
                        </span>
                      </div>
                    </div>
                    <div className="col-xs-12 col-lg-4">
                      <div className="form-group">
                        <label>Sobrenome: </label>
                        <Field
                          type="text"
                          name="sobrenome"
                          className="form-control input-sm"
                        />
                        <span className="error-message">
                          <ErrorMessage name="sobrenome" />
                        </span>
                      </div>
                    </div>
                    <div className="col-xs-12 col-lg-2">
                      <div className="form-group">
                        <label>Data de Nasc: </label>
                        <Field
                          type="date"
                          name="dataNasc"
                          className="form-control input-sm"
                        />
                        <span className="error-message">
                          <ErrorMessage name="dataNasc" />
                        </span>
                      </div>
                    </div>
                    {/*<div className="col-xs-12 col-lg-2 ">
                        <div className="form-group ">
                          <label>Sexo: </label>
                          <Field
                            component="select"
                            className="form-control input-sm"
                            name="sexo"
                          >
                            <option value="">SELECIONE </option>
                            <option value="M">MASCULINO </option>
                            <option value="F">FEMININO </option>
                            <option value="O">OUTROS </option>
                          </Field>
                          <span className="error-message">
                            <ErrorMessage name="sexo" />
                          </span>
                        </div>
                      </div>
                      */}
                  </div>
                  <div className="row">
                    <div className=" col-xs-12 col-lg-4">
                      <div className="form-group ">
                        <label>E-mail</label>
                        <Field
                          type="email"
                          className="form-control input-sm "
                          name="email"
                        />
                        <span className="error-message">
                          <ErrorMessage name="email" />
                        </span>
                      </div>
                    </div>

                    <div className="col-md-12 col-lg-4">
                      <div className="row">
                        <div className=" col-xs-3 col-lg-4">
                          <label>DDD</label>
                          <Field
                            className="form-control input-sm"
                            name="dddCel"
                            maxLength="2"
                          />
                          <span className="error-message">
                            <ErrorMessage name="dddCel" />
                          </span>
                        </div>
                        <div className=" col-xs-9 col-lg-8">
                          <label>Celular</label>
                          <Field name="celular">
                            {({ field, form }) => (
                              <MaskedInput
                                {...field}
                                className="form-control input-sm"
                                mask="11111-1111"
                                onBlur={(e) => {
                                  form.setFieldTouched("celular", true);
                                  form.setFieldValue("celular", e.target.value);
                                }}
                              />
                            )}
                          </Field>
                          <span className="error-message">
                            <ErrorMessage name="celular" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>

                <Card textoHeader="Endereço">
                  <div className="row">
                    <div className="col-xs-12 col-lg-3">
                      <div className="form-group ">
                        <label>CEP</label>
                        <div className="input-group">
                          <Field name="cep">
                            {({ field, form }) => (
                              <MaskedInput
                                {...field}
                                type="text"
                                className="form-control input-sm valid"
                                name="cep"
                                id="cep"
                                mask="11111-111"
                                onBlur={async (e) => {
                                  form.setFieldTouched("cep", true); // marca como tocado
                                  form.setFieldValue("cep", e.target.value); // atualiza valor
                                  // busca e preenche endereço pelo CEP
                                  await preencheEndereco(
                                    e,
                                    e.target.value,
                                    form.setFieldValue,
                                  );
                                }}
                              />
                            )}
                          </Field>
                          <span className="error-message">
                            <ErrorMessage name="cep" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className=" col-xs-12 col-lg-7">
                      <div className="form-group " id="DivEndereco">
                        <label>Endereco</label>
                        <Field
                          type="text"
                          className="form-control input-sm valid"
                          name="endereco"
                        />
                        <span className="error-message">
                          <ErrorMessage name="endereco" />
                        </span>
                      </div>
                    </div>

                    <div className=" col-xs-12 col-lg-2">
                      <div className="form-group ">
                        <label>Número</label>
                        <Field
                          type="text"
                          className="form-control input-sm"
                          name="numero"
                        />
                        <span className="error-message">
                          <ErrorMessage name="numero" />
                        </span>
                      </div>
                    </div>

                    <div className="col-xs-12 col-lg-3 ">
                      <div className="form-group ">
                        <label>Complemento</label>
                        <Field
                          type="text"
                          className="form-control input-sm "
                          name="complemento"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-lg-3 ">
                      <div className="form-group " id="DivBairro">
                        <label>Bairro</label>
                        <Field
                          type="text"
                          className="form-control input-sm valid"
                          name="bairro"
                        />
                        <span className="error-message">
                          <ErrorMessage name="bairro" />
                        </span>
                      </div>
                    </div>

                    <div className="col-xs-12 col-lg-2 ">
                      <div className="form-group ">
                        <label>UF</label>
                        <Field
                          type="text"
                          className="form-control input-sm valid"
                          name="uf"
                          maxLength="2"
                        />
                        <span className="error-message">
                          <ErrorMessage name="uf" />
                        </span>
                      </div>
                    </div>

                    <div className="col-xs-12 col-lg-3 ">
                      <div className="form-group ">
                        <label>Cidade</label>
                        <Field
                          type="text"
                          className="form-control input-sm valid"
                          name="cidade"
                        />
                        <span className="error-message">
                          <ErrorMessage name="cidade" />
                        </span>
                      </div>
                    </div>
                  </div>
                </Card>

                {/*<Card textoHeader="Contatos">
                  <div className="row">
                    <div className=" col-xs-12 col-lg-4">
                      <div className="form-group ">
                        <label>E-mail</label>
                        <Field
                          type="email"
                          className="form-control input-sm "
                          name="email"
                        />
                        <span className="error-message">
                          <ErrorMessage name="email" />
                        </span>
                      </div>
                    </div>

                    <div className="col-md-12 col-lg-4">
                      <div className="row">
                        <div className=" col-xs-3 col-lg-4">
                          <label>DDD</label>
                          <Field
                            className="form-control input-sm"
                            name="dddCel"
                            maxLength="2"
                          />
                          <span className="error-message">
                            <ErrorMessage name="dddCel" />
                          </span>
                        </div>
                        <div className=" col-xs-9 col-lg-8">
                          <label>Celular</label>
                          <Field name="celular">
                            {({ field, form }) => (
                              <MaskedInput
                                {...field}
                                className="form-control input-sm"
                                mask="11111-1111"
                                onBlur={(e) => {
                                  form.setFieldTouched("celular", true);
                                  form.setFieldValue("celular", e.target.value);
                                }}
                              />
                            )}
                          </Field>
                          <span className="error-message">
                            <ErrorMessage name="celular" />
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12 col-lg-4">
                      <div className="row">
                        <div className="col-xs-3 col-lg-4">
                          <label>DDD</label>
                          <Field
                            className="form-control input-sm"
                            name="ddd_telefone"
                            maxLength="2"
                          />
                          <span className="error-message">
                            <ErrorMessage name="ddd_telefone" />
                          </span>
                        </div>
                        <div className="col-xs-9 col-lg-8">
                          <label>Telefone</label>
                          <MaskedInput
                            className="form-control input-sm"
                            name="telefone"
                            mask="1111-1111"
                            onChange={(ev) =>
                              setFieldValue("telefone", ev.target.value)
                            }
                          />
                          <span className="error-message">
                            <ErrorMessage name="telefone" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>*/}
                {/*<button
                  type="button"
                  className="btn btn-primary btn-quadrado"
                  id="btnInserirDependente"
                >
                  <i className="fa fa-plus-circle"></i> Adicionar Dependente
                </button>

                <div style={{ marginBottom: "20px" }}>
                  <small style={{ fontSize: "11px" }}>
                    * Máximo de 3 dependentes
                  </small>
                  <p></p>
                </div>*/}

                {/* FORMULÁRIO DE CADASTRO DE DEPENDENTES*/}
                {plano.titulo.toLocaleLowerCase() !== "titular" &&
                  Array.from({ length: plano.qtdeDependentes }).map((_, i) => (
                    <Card
                      textoHeader={`Dependente - ${i + 1}`}
                      key={i}
                      classNameCardHeader="card-header-dependente"
                    >
                      <div className="row">
                        <div className="col-xs-12 col-lg-3 ">
                          <div className="form-group">
                            <label>CPF: </label>

                            <Field name={`dependente[${i}][cpf]`}>
                              {({ field, form }) => (
                                <MaskedInput
                                  {...field}
                                  type="text"
                                  className="form-control input-sm cpf_valido"
                                  mask="111.111.111-11"
                                  onBlur={async (e) => {
                                    form.setFieldTouched(
                                      `dependente[${i}][cpf]`,
                                      true,
                                    ); // marca como tocado
                                    form.setFieldValue(
                                      `dependente[${i}][cpf]`,
                                      e.target.value,
                                    ); // atualiza valor
                                    //busca os dados do cliente pelo CPF
                                    await preencheDadosCpf(
                                      e,
                                      e.target.value,
                                      form.setFieldValue,
                                    );
                                  }}
                                />
                              )}
                            </Field>
                          </div>
                        </div>

                        <div className="col-xs-12 col-lg-4 ">
                          <div className="form-group">
                            <label>Nome Completo: </label>
                            <Field
                              type="text"
                              className="form-control input-sm cpf_valido"
                              name={`dependente[${i}][nome]`}
                            />
                          </div>
                        </div>

                        <div className="col-xs-12 col-lg-2 ">
                          <div className="form-group ">
                            <label>Data de Nascimento: </label>
                            <Field
                              type="date"
                              className="form-control input-sm"
                              name={`dependente[${i}][data_nasc]`}
                            />
                          </div>
                        </div>

                        <div className="col-xs-12 col-lg-2 ">
                          <div className="form-group ">
                            <label>Grau de Parentesco</label>
                            <Field
                              component="select"
                              className="form-control input-sm "
                              name={`dependente[${i}][grau_parentesco]`}
                            >
                              <option value="">SELECIONE</option>
                              <option value="Bisavós">Bisavós</option>
                              <option value="Avós">Avós</option>
                              <option value="Pais">Pais</option>
                              <option value="Cônjuge">Cônjuge</option>
                              <option value="Filhos">Filhos</option>
                              <option value="Enteados">Enteados</option>
                              <option value="Netos">Netos</option>
                              <option value="Bisnetos">Bisnetos</option>
                              <option value="Sogros">Sogros</option>
                              <option value="Cunhados">Cunhados</option>
                              <option value="Genro/Nora">Genro/Nora</option>
                              <option value="Primos">Primos</option>
                              <option value="Outros">Outros</option>
                            </Field>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className=" col-xs-12 col-lg-4">
                          <div className="form-group ">
                            <label>E-mail</label>
                            <Field
                              type="email"
                              className="form-control input-sm "
                              name={`dependente[${i}][email]`}
                            />
                            <span className="error-message">
                              <ErrorMessage name="email" />
                            </span>
                          </div>
                        </div>

                        <div className="col-md-12 col-lg-4">
                          <Field
                            type="hidden"
                            className="form-control input-sm"
                            name={`dependente[${i}][id]`}
                          />
                          <div className="row">
                            <div className=" col-xs-3 col-lg-4">
                              <label>DDD</label>
                              <Field
                                className="form-control input-sm"
                                name={`dependente[${i}][dddCel]`}
                                maxLength="2"
                              />
                              <span className="error-message">
                                <ErrorMessage name="dddCel" />
                              </span>
                            </div>
                            <div className=" col-xs-9 col-lg-8">
                              <label>Celular</label>

                              <Field name={`dependente[${i}][celular]`}>
                                {({ field, form }) => (
                                  <MaskedInput
                                    {...field}
                                    className="form-control input-sm"
                                    mask="11111-1111"
                                    onBlur={(e) => {
                                      form.setFieldTouched(
                                        `dependente[${i}][celular]`,
                                        true,
                                      );
                                      form.setFieldValue(
                                        `dependente[${i}][celular]`,
                                        e.target.value,
                                      );
                                    }}
                                  />
                                )}
                              </Field>
                              <span className="error-message">
                                <ErrorMessage name="celular" />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  ))}

                {/* <Card textoHeader="Código do vendedor">
                    <div className="row">
                      <div className="col-xs-12 col-lg-12 ">
                        <p>
                          Caso seu cadastro tenha sido feito por intermédio de
                          um vendedor, informe o código do mesmo no campo
                          abaixo.
                        </p>
                        <span className="obs">OBS: dado não obrigatório</span>
                      </div>
                    </div>
                    <div className="row" style={{ marginTop: "20px" }}>
                      <div className="col-xs-12 col-lg-2">
                        <div className="form-group ">
                          <label>Código do vendedor: </label>
                          <Field type="text" name="codigo_vendedor" />
                        </div>
                      </div>
                    </div>
                  </Card>

                 <Card textoHeader="Dados para Login">
                    <div className="row">
                      <div className="col-xs-6 col-lg-3 ">
                        <div className="form-group ">
                          <label>Senha: </label>
                          <Field type="password" name="senha" />
                          <span className="error-message">
                            <ErrorMessage name="senha" />
                          </span>
                        </div>
                      </div>

                      <div className="col-xs-6 col-lg-3 ">
                        <div className="form-group ">
                          <label>Confirme a senha: </label>
                          <Field type="password" name="confirmaSenha" />
                          <span className="error-message">
                            <ErrorMessage name="confirmaSenha" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </Card>{*/}
                <button
                  type="submit"
                  className="btn bg-red color-white btn-lg float-right"
                >
                  Cadastrar
                </button>
              </Form>
            )}
          />
        </section>
      </div>
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    plano: {
      id: state.plano.id,
      titulo: state.plano.titulo,
      valor: state.plano.valor,
      idGetnet: state.plano.idPlanoGetnet,
      beneficios: state.plano.beneficios,
      qtdeDependentes: state.plano.qtdeDependentes,
    },
    clientName: state.apiGetnet.clientName,
  };
};

const cadatroConnect = connect(mapStateToProps, {
  exibeModal,
  CreateHeadersApiGetnet,
  SaveDataClientGetNet,
  editIdCliente,
})(Cadastro);

export default cadatroConnect;
